/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var OperationTypeEnum;

(function (OperationTypeEnum) {
  OperationTypeEnum["DRY_VAN"] = "dryVan";
  OperationTypeEnum["FLAT_BED"] = "flatBed";
  OperationTypeEnum["REFRIGERATED_FREIGHT"] = "refrigeratedFreight";
  OperationTypeEnum["AUTOMOBILE_HAULER"] = "automobileHauler";
  OperationTypeEnum["CONTAINERIZED_FREIGHT"] = "containerizedFreight";
  OperationTypeEnum["HOUSEHOLD_GOODS"] = "householdGoods";
  OperationTypeEnum["MOBILE_HAULER"] = "mobileHauler";
  OperationTypeEnum["DOUBLE_TRAILERS"] = "doubleTrailers";
  OperationTypeEnum["COURIER"] = "courier";
})(OperationTypeEnum || (OperationTypeEnum = {}));